export default __webpack_public_path__ + "static/media/article_image_default.646f6b77.png";